import type { LoaderFunctionArgs } from "@remix-run/cloudflare";
import Container from "~/components/layout/Container";
import { siteTitle } from "../_index";
import References from "../features/References";
import Slogans from "../features/Slogans";
import HeroSection from "./features/Hero";
import MissionAccordion from "./features/MissionAccordion";
import ServicesSection from "./features/Services";

export const loader = ({ params }: LoaderFunctionArgs) => {
  return {};
};
export const meta = () => {
  return [{
    title: `Kurumsal | Hakkımızda | UTB Trader & Support | UTB Support Kimdir? | Biz Kimiz? | Neler Yaparız? | ${siteTitle}`,
  }]
}
export default function Kurumsal() {
  return (
    <div className="pt-[122px]">
      <img src="/assets/utb-trader-support-kurumsal.webp" alt="Kurumsal" className="w-full h-auto max-h-[400px] object-contain bg-white" />
      <div className="bg-[#f5f5f5]">
        <Container className="flex-wrap">
          <div className="flex flex-wrap w-full md:w-9/12">
            <h2 className="text-3xl w-full justify-center font-bold font-raleway text-[30px] tracking-wide my-16">UTB SUPPORT</h2>
            <h3 className="text-3xl w-full justify-between font-raleway text-[22px] mb-5 text-[#555555] after:content-[''] after:block after:w-[44px] after:h-[4px] after:bg-[#16437c] after:my-5"><b>Hakkımızda</b> - Biz Kimiz? - Neler Yaparız?
            </h3>
          </div>
          <div className="w-full md:w-3/12 mb-10 md:mb-0 md:pt-40"><a href="/hizmetlerimiz" className="bg-[#16437c] float-right text-white text-base font-lato font-bold px-4 py-2">Hizmetlerimize Göz Atın</a></div>
          <div className="w-full md:w-9/12 pb-10 [&_p]:mb-5 [&_p]:text-justify">
            <p className="text-[14px] font-lato font-normal text-[#555555]">
              UTB Support, 2022 yılında yenilenen vizyonu ve dinamik ekibiyle 20 yıllık tecrübesini daha da ileriye taşıyor. Firmamız, ithalat/ihracat, eğitim ve danışmanlık hizmetleri sunarak dış ticaret alanındaki bilgi ve birikimlerini iş ortaklarıyla paylaşmaktadır.
            </p>
            <p className="text-base font-lato font-normal text-[#555555]">
              İngilizce, Rusça, Almanca, Arapça ve Fransızca dillerinde hizmet vererek, yurt içi ve yurt dışındaki firmalar için çözüm ortaklığı yapmaktadır. İhracat danışmanlığı, hedef Pazar çalışmaları ve eğitim hizmetleri ile uluslararası iletişimi kolaylaştıran diğer desteklerle iş ortaklarımızın küresel arenada başarılı olmasına katkı sağlamaktayız.
            </p>
            <p className="text-base font-lato font-normal text-[#555555]">
              İhracat çalışmalarında UTB Trade & Trader, UTB Support olarak gelecekteki başarıyı yakalamak için teknolojiyi yakından takip ediyor ve üretici firmalarla iş birliği yapıyoruz. Sektördeki değişimleri izleyerek, iş ortaklarımız için pazar araştırmaları ve gümrük ve nakliye süreçlerinde danışmanlık hizmetleri sunuyoruz. Böylece, iş ortaklarımızın tüm aşamaları zahmetsizce tamamlamalarını sağlıyoruz.
            </p>
            <p className="text-base font-lato font-normal text-[#555555]">
              Kaliteli hizmet sunmanın eğitimle mümkün olduğuna inanıyoruz. Gerçekleştirdiğimiz etkinliklerle ekibimizin yetkinliklerini artırıyor ve güçlendiriyoruz. Tecrübeli ve genç kadromuzla, eğitim hizmetlerimizi sürdürerek sektörün ihtiyaçlarına yönelik çözümler üretiyoruz.
            </p>
            <p className="text-base font-lato font-normal text-[#555555]">
              İthalatta yurt dışı menşeli ürünlerde yaşanan tedarik sıkıntılarına güvenilir çözümler getiriyoruz. Kurduğumuz sağlam bağlantılar sayesinde, kaliteli ve uygun fiyatlı ürünleri hedef ithalat pazarı çalışmalarımızla iş ortaklarımıza zahmetsizce ulaştırıyoruz. İş birliği yaptığımız firmalar, ürünlerinin yurt içinde güvenle satışını gerçekleştirmektedir.
            </p>
          </div>
        </Container>
        <ServicesSection />
        <HeroSection slogan="SINIRLARI AŞAN ÇÖZÜMLER, GÜÇLÜ İŞBİRLİKLERİ." />
        <MissionAccordion />
      </div>
      <Slogans />
      <References />
    </div>
  )
}
